<template>
  <div class="banner-cnt">
    <div>
      <swiper class="m-swiper m-swiper-main" ref="mySwiper" :options="swiperOptions">
        <swiper-slide v-for="(item, index) in bannerList" :key="index" >
          <div class="swiper-item" @click="goLogin" >
                        <img :src="item" alt="" fit="fill" draggable="false" class="banner-img"/>
            <div class="jump-area"></div>
          </div>
        </swiper-slide>
        <div class="swiper-pagination"
             slot="pagination"></div>
      </swiper>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      activeIndex: 0,
      swiperOptions: {
        autoplay: true,
        resizeReInit: true, //window如果resize则重新初始化
        speed: 550,
        loop: true, // 循环模式选项
        autoHeight: true, //高度随内容变化
        updateOnImagesReady: true,
        preventLinks: true,
        preventLinksPropagation: true,
        paginationClickable: true,
        // 如果需要分页器
        pagination: {
          el: '.swiper-pagination', //与slot="pagination"处 class 一致
          clickable: true, //轮播按钮支持点击
          paginationCustomRender: function (swiper, current, total) {
            var customPaginationHtml = "";
            for (var i = 0; i < total; i++) {
              //判断哪个分页器此刻应该被激活
              if (i == current - 1) {
                customPaginationHtml +=
                    '<span class="swiper-pagination-customs swiper-pagination-customs-active"></span>';
              } else {
                customPaginationHtml +=
                    '<span class="swiper-pagination-customs"></span>';
              }
            }
            return '<span class="swiperPag">' + customPaginationHtml + '</span>';
          }
        },
      },
      slide: 0,
      sliding: null,
      bannerList: [
        require('@/assets/images/index//banner/banner4.png'),
        require('@/assets/images/index//banner/banner3.png'),
        require('@/assets/images/index//banner/banner2.png'),
        require('@/assets/images/index//banner/banner1.png'),
        require('@/assets/images/index//banner/banner6.png'),
      ],
    }
  },
  methods: {
    goLogin: function () {
      this.$router.push("/login");
    },
  }
}
</script>

<style scoped lang="scss">
//.banner-cnt {
//  position: relative;
//  height: 544px;
//}
.swiper-item {
  width: 100%; /* 设置轮播图的宽度为100% */
  height: auto; /* 设置轮播图的高度自动适应内容 */
  //height: 544px;
  position: relative;
  background-size: 100%;
  background-repeat: no-repeat;
}

.banner-img {
  height: 100%;
  width: 100%;
  cursor: pointer;
}

.m-swiper {
  //height: 544px;
}


::v-deep .swiper-pagination-bullet {
  display: inline-block;
  vertical-align: baseline;
  zoom: 1;
  width: 30px;
  height: 3px;
  border-radius: 0;
}

::v-deep .swiper-pagination-bullet-active {
  background: #fff;
}


.jump-area {
  position: absolute;
  bottom: 0;
  width: 500px;
  height: 240px;
  z-index: 10;
  cursor: pointer;
}

</style>
